var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingLabelRVip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 26,
    viewBox: "0 0 52 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=vip_05_rvip, size=none",
    clipPath: "url(#clip0_4091_32151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 13C0.000976562 5.8203 5.82127 0 13.001 0H39.001C46.1807 0 52.001 5.82029 52.001 13C52.001 20.1797 46.1807 26 39.001 26H13.001C5.82127 26 0.000976562 20.1797 0.000976562 13ZM13.001 2C6.92584 2 2.00098 6.92486 2.00098 13C2.00098 19.0751 6.92584 24 13.001 24H39.001C45.0761 24 50.001 19.0751 50.001 13C50.001 6.92487 45.0761 2 39.001 2H13.001Z",
    fill: "#8D35C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2993 18V8.09945H15.1764C17.4292 8.09945 18.7199 9.37086 18.7199 11.3239C18.7199 12.6823 18.1011 13.6637 16.9699 14.1471L19.0777 18H16.8007L14.9202 14.4807H13.3539V18H11.2993ZM13.3539 12.8177H14.7993C16.0176 12.8177 16.6074 12.3149 16.6074 11.3239C16.6074 10.3329 16.0176 9.7866 14.7945 9.7866H13.3539V12.8177ZM21.6023 8.09945L24.0146 15.6554H24.1064L26.5235 8.09945H28.8053L25.3827 18H22.7383L19.3157 8.09945H21.6023ZM31.975 8.09945V18H29.9204V8.09945H31.975ZM33.6529 18V8.09945H37.5299C39.7827 8.09945 41.0734 9.48688 41.0734 11.4448C41.0734 13.4123 39.7634 14.7756 37.4864 14.7756H35.7074V18H33.6529ZM35.7074 13.1174H37.1529C38.3711 13.1174 38.9609 12.4358 38.9609 11.4448C38.9609 10.4489 38.3711 9.7866 37.148 9.7866H35.7074V13.1174Z",
    fill: "#8D35C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_32151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 26,
    fill: "white",
    transform: "translate(0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingLabelRVip);
export default __webpack_public_path__ + "static/media/rating_label_rVip.57d448fd3769fe0ffad0b819c5c1cc1b.svg";
export { ForwardRef as ReactComponent };